import React, { lazy } from "react";
import {
  USER_ADD,
  USER,
  USER_EDIT,
  PORTFOLIO,
  PORTFOLIO_VIEW,
  ROLE,
  ROLE_PERMISSION,
  CLIENT,
  CLIENT_ADD,
  CLIENT_EDIT,
  TAX,
  SERVICE,
  EXPENSE,
  EXPENSE_EDIT,
  EXPENSE_ADD,
  CASH_CREDIT_DEBIT,
  CASH_BOOK,
  CHEQUE_BOOK,
  VENDOR,
  VENDOR_ADD,
  REPORT,
  INVOICE,
  INVOICE_ADD,
  INVOICE_EDIT,
  HOME,
  CHANGE_PASSWORD,
  CHEQUE_CREDIT_DEBIT,
  VENDOR_EDIT,
  BILL,
  BILL_ADD,
  BILL_EDIT,
  EDIT_PROFILE,
} from "@jumbo/constants/routes";
import PrivateRoute from "./PrivateRoute";
import Bill from "app/pages/bill/view";
import AddAndUpdateBill from "app/pages/bill/addAndUpdate";
import EditProfile from "app/pages/auth/EditProfile";
import Error401 from "app/pages/401";

const Page = lazy(() => import("@jumbo/shared/Page"));
const Home = lazy(() => import("../pages/home"));
const User = lazy(() => import("../pages/user/view"));
const UpdateAddUser = lazy(() => import("../pages/user/addAndUpdate"));
const Client = lazy(() => import("../pages/client/view"));
const AddAndUpdateClient = lazy(() => import("../pages/client/addAndUpdate"));
const PortfolioDetails = lazy(() =>
  import("../pages/portfolio/view/portfolioDetails")
);
const ViewPortfolio = lazy(() => import("../pages/portfolio/view"));
const Tax = lazy(() => import("../pages/tax/view"));
const Service = lazy(() => import("../pages/service/view"));
const CashAndCheque = lazy(() => import("../pages/cashAndCheque/view"));
const CreditAndDebit = lazy(() =>
  import("../pages/cashAndCheque/creditAndDebit")
);
const Role = lazy(() => import("app/pages/Role/view"));
const Permission = lazy(() => import("app/pages/Role/permission"));
const Vendor = lazy(() => import("app/pages/vendor/view"));
const AddAndUpdateVendor = lazy(() => import("app/pages/vendor/addAndUpdate"));
const Expense = lazy(() => import("app/pages/expense/view"));
const AddAndUpdateExpense = lazy(() =>
  import("app/pages/expense/addAndUpdate")
);
const Report = lazy(() => import("../pages/report/view"));
const Invoice = lazy(() => import("../pages/invoice/view"));
const AddAndUpdateInvoice = lazy(() => import("../pages/invoice/addAndUpdate"));
const ChangePassword = lazy(() => import("../pages/auth/ChangePassword"));

const dashboardRoutes = [
  {
    path: '401',
    element: (
      <PrivateRoute>
        <Page component={Error401} />
      </PrivateRoute>
    ),
  },
  {
    path: HOME,
    element: (
      <PrivateRoute permission="dashboard">
        <Page component={Home} />
      </PrivateRoute>
    ),
  },
  {
    path: USER,
    element: (
      <PrivateRoute permission="user-list">
        <Page component={User} />
      </PrivateRoute>
    ),
  },
  {
    path: USER_ADD,
    element: (
      <PrivateRoute permission="user-create">
        <Page component={UpdateAddUser} />
      </PrivateRoute>
    ),
  },
  {
    path: USER_EDIT,
    element: (
      <PrivateRoute permission="user-update">
        <Page component={UpdateAddUser} />
      </PrivateRoute>
    ),
  },

  {
    path: PORTFOLIO,
    element: (
      <PrivateRoute permission="investment-list">
        <Page component={ViewPortfolio} />
      </PrivateRoute>
    ),
  },
  {
    path: PORTFOLIO_VIEW,
    element: (
      <PrivateRoute permission="stock-view" >
        <Page component={PortfolioDetails} />
      </PrivateRoute>
    ),
  },
  {
    path: CLIENT,
    element: (
      <PrivateRoute permission="parti-list">
        <Page component={Client} />
      </PrivateRoute>
    ),
  },
  {
    path: CLIENT_ADD,
    element: (
      <PrivateRoute permission="parti-create">
        <Page component={AddAndUpdateClient} />
      </PrivateRoute>
    ),
  },
  {
    path: CLIENT_EDIT,
    element: (
      <PrivateRoute permission="parti-update">
        <Page component={AddAndUpdateClient} />
      </PrivateRoute>
    ),
  },
  {
    path: ROLE,
    element: (
      <PrivateRoute permission="role-list">
        <Page component={Role} />
      </PrivateRoute>
    ),
  },
  {
    path: ROLE_PERMISSION,
    element: (
      <PrivateRoute permission="permission-list">
        <Page component={Permission} />
      </PrivateRoute>
    ),
  },
  {
    path: TAX,
    element: (
      <PrivateRoute permission="tax-list">
        <Page component={Tax} />
      </PrivateRoute>
    ),
  },
  {
    path: SERVICE,
    element: (
      <PrivateRoute permission="service-list">
        <Page component={Service} />
      </PrivateRoute>
    ),
  },
  {
    path: VENDOR,
    element: (
      <PrivateRoute permission="parti-list">
        <Page component={Vendor} />
      </PrivateRoute>
    ),
  },
  {
    path: VENDOR_ADD,
    element: (
      <PrivateRoute permission="parti-create">
        <Page component={AddAndUpdateVendor} />
      </PrivateRoute>
    ),
  },
  {
    path: VENDOR_EDIT,
    element: (
      <PrivateRoute permission="parti-update">
        <Page component={AddAndUpdateVendor} />
      </PrivateRoute>
    ),
  },
  {
    path: EXPENSE,
    element: (
      <PrivateRoute permission="entry-book-list">
        <Page component={Expense} />
      </PrivateRoute>
    ),
  },
  {
    path: EXPENSE_ADD,
    element: (
      <PrivateRoute permission="entry-book-create" >
        <Page component={AddAndUpdateExpense} />
      </PrivateRoute>
    ),
  },
  {
    path: EXPENSE_EDIT,
    element: (
      <PrivateRoute permission="entry-book-create">
        <Page component={AddAndUpdateExpense} />
      </PrivateRoute>
    ),
  },
  {
    path: CASH_BOOK,
    element: (
      <PrivateRoute permission="entry-book-list">
        <Page component={CashAndCheque} />
      </PrivateRoute>
    ),
  },
  {
    path: CHEQUE_BOOK,
    element: (
      <PrivateRoute permission="entry-book-list">
        <Page component={CashAndCheque} />
      </PrivateRoute>
    ),
  },
  {
    path: CASH_CREDIT_DEBIT,
    element: (
      <PrivateRoute permission="entry-book-create">
        <Page component={CreditAndDebit} />
      </PrivateRoute>
    ),
  },
  {
    path: CHEQUE_CREDIT_DEBIT,
    element: (
      <PrivateRoute permission="entry-book-create">
        <Page component={CreditAndDebit} />
      </PrivateRoute>
    ),
  },
  {
    path: REPORT,
    element: (
      <PrivateRoute>
        <Page component={Report} />
      </PrivateRoute>
    ),
  },
  {
    path: INVOICE,
    element: (
      <PrivateRoute permission="invoice-list">
        <Page component={Invoice} />
      </PrivateRoute>
    ),
  },
  {
    path: INVOICE_ADD,
    element: (
      <PrivateRoute permission="invoice-create" >
        <Page component={AddAndUpdateInvoice} />
      </PrivateRoute>
    ),
  },
  {
    path: INVOICE_EDIT,
    element: (
      <PrivateRoute permission="invoice-update">
        <Page component={AddAndUpdateInvoice} />
      </PrivateRoute>
    ),
  },
  {
    path: CHANGE_PASSWORD,
    element: (
      <PrivateRoute>
        <Page component={ChangePassword} />
      </PrivateRoute>
    ),
  },
  {
    path: BILL,
    element: (
      <PrivateRoute permission="bill-list">
        <Page component={Bill} />
      </PrivateRoute>
    ),
  },
  {
    path: BILL_ADD,
    element: (
      <PrivateRoute permission="bill-create">
        <Page component={AddAndUpdateBill} />
      </PrivateRoute>
    ),
  },
  {
    path: BILL_EDIT,
    element: (
      <PrivateRoute permission="bill-update" >
        <Page component={AddAndUpdateBill} />
      </PrivateRoute>
    ),
  },
  {
    path: EDIT_PROFILE,
    element: (
      <PrivateRoute>
        <Page component={EditProfile} />
      </PrivateRoute>
    ),
  },
];

export default dashboardRoutes;
